module.exports = __webpack_public_path__ + "img/contact_icon.372baca4.svg";